<div class="sc-modal">

  <div class="modal-content" [ngClass]="{'alert-modal-content': scType === 'alert',
        'notification-modal-content' : scType === 'notification'}">
    <!-- Header -->
    <div class="modal-header" mat-dialog-title>
      <h4 class="modal-message-title pull-left">{{ scTitle }}</h4>
      @if (scMinimizable && !isMinimized) {
        <button mat-icon-button title="Minimize" tabindex="-1" (click)="minimize()">
          <mat-icon>remove</mat-icon>
        </button>
      }

      @if (scMinimizable && isMinimized) {
        <button mat-icon-button title="Maximize" tabindex="-1" (click)="maximize()">
          <mat-icon>check_box_outline_blank</mat-icon>
        </button>
      }

      @if (scShowHeaderCloseButton) {
        <button mat-icon-button title="Close" tabindex="-1" (click)="hide()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    <!-- Body -->
    @if (!isMinimized) {
      <div mat-dialog-content class="modal-body">
        <ng-content select="[modal-body]"></ng-content>
      </div>
    }

    <!-- Footer -->
    @if (!isMinimized) {
      <div mat-dialog-actions class="modal-footer">
        <ng-content select="[modal-footer]"></ng-content>
      </div>
    }
  </div>

</div>


<!-- mat-mdc-dialog-surface -->

<!--<div class="sc-modal"
(dismissed)="onModalHide()"
(hide)="onModalHide()">
</div>-->
<!--<ng-template #content let-c="close" let-d="dismiss">
</ng-template>-->
